import { values, flatten, find } from 'lodash/fp';
import { filter, path, pipe, propEq, propOr } from 'ramda';
import { getShopUser } from '../shops/selectors';
import { USER_TYPES } from '../../auth/constants';

export const getIds = (state) => state.ids;
export const getBrandList = (state) => state.brand;

export const getShopUsers = propOr([], 'users');
export const getBarberUser = (state, userId) =>
  pipe(
    path(['admin', 'users', 'barberUsersByShop']),
    values,
    flatten,
    find((user) => user.id === userId)
  )(state);
export const getBarberUsersForShop = (state, shopId) => path(['admin', 'users', 'barberUsersByShop', shopId])(state);

export const getUser = (state, id) => state.admin.users.byId[id];
export const getUsers = (state) => {
  const ids = getIds(state.admin.users.list);
  return ids.map((id) => getUser(state, id));
};

export const getStaffMembers = (state) => state.admin.users.list.staffMembers;

export const getPagination = (state) => state.admin.users.pagination;

export const getIsConnectedUser = (state, userId) => {
  const user = getUser(state, userId);
  if (user) {
    return (user.shops && user.shops.length) > 0 || (user.barbers && user.barbers.length) > 0 || user.brand !== null;
  }

  return !!getBarberUser(state, userId) || !!getShopUser(state, userId);
};

export const getAdminUsers = pipe(
  getUsers,
  filter((user) => user.kind === USER_TYPES.regularAdmin || user.kind === USER_TYPES.agent)
);

export const getPermissionsForKind = (state, kind) =>
  filter((permission) => permission.forUserKind === kind)(state.admin.users.permissions);
